import { useState } from "react";
import {
  TooltipProvider,
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "@/components/ui/tooltip";
import { Badge } from "@/components/ui/badge";
import { Copy, Check } from "lucide-react";

export const ClipboardTooltip = ({
  value,
  content,
  variant = "outline",
  disableTooltip = false,
  className = "",
}: {
  value: string;
  content?: string;
  variant?:
    | "outline"
    | "secondary"
    | "ghost"
    | "default"
    | "destructive"
    | "link"
    | "subtle"
    | "light"
    | "success"
    | "warning"
    | "info"
    | null
    | undefined;
  disableTooltip?: boolean;
  className?: string;
}) => {
  const [copied, setCopied] = useState(false);
  const [open, setOpen] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);

      if (!disableTooltip) {
        setOpen(true); // ✅ Forzar que el tooltip se abra inmediatamente
      }

      // Reset después de 2 segundos
      setTimeout(() => {
        setCopied(false);
        if (!disableTooltip) {
          setOpen(false);
        }
      }, 2000);
    } catch (err) {
      console.error("Error al copiar:", err);
    }
  };

  const BadgeContent = (
    <Badge
      variant={variant}
      className={`px-2 py-1 text-xs cursor-pointer transition-colors ${
        copied
          ? "bg-primary/10  border-primary-300 dark:bg-primary-900 dark:text-primary-400"
          : " dark:hover:bg-background dark:hover:text-primary-400"
      } ${className}`}
      onClick={handleCopy}
    >
      {content || value}
      {copied ? <Check className="h-3 w-3" /> : <Copy className="h-3 w-3" />}
    </Badge>
  );

  // Si disableTooltip es true, mostrar solo el badge sin tooltip
  if (disableTooltip) {
    return <div className="flex items-center space-x-2">{BadgeContent}</div>;
  }

  return (
    <div className="flex items-center space-x-2">
      <TooltipProvider>
        <Tooltip open={open} onOpenChange={setOpen}>
          <TooltipTrigger asChild>{BadgeContent}</TooltipTrigger>
          <TooltipContent>
            <div>{copied ? "¡Copiado!" : "Copiar código"}</div>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};
